// components/HLSPlaylistPlayer.tsx
import React, { useEffect, useRef, useState } from "react";
import Hls from "hls.js";

interface HLSPlaylistPlayerProps {
  playlist: string[]; // массив ссылок на .m3u8
}

export const HLSPlaylistPlayer: React.FC = () => {
  const playlist = [
    "https://fastapi.dev.torsunov.pro/streaming/vod_playlist?media=01ba5e1e28b1449bbc71d7ef98a3fed0",
  ];
  const videoRef = useRef<HTMLVideoElement>(null);
  const hlsRef = useRef<Hls | null>(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const loadVideo = (url: string) => {
    const video = videoRef.current;
    if (!video) return;

    // Очистить предыдущий HLS
    if (hlsRef.current) {
      hlsRef.current.destroy();
    }

    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(url);
      hls.attachMedia(video);
      hlsRef.current = hls;

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        video.play();
      });
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = url;
      video.addEventListener("loadedmetadata", () => {
        video.play();
      });
    }
  };

  useEffect(() => {
    if (playlist.length > 0) {
      loadVideo(playlist[currentIndex]);
    }

    return () => {
      if (hlsRef.current) {
        hlsRef.current.destroy();
      }
    };
  }, [currentIndex, playlist]);

  const handleEnded = () => {
    if (currentIndex < playlist.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      console.log("Всё видео проиграно");
    }
  };

  return (
    <div>
      <video
        ref={videoRef}
        controls
        onEnded={handleEnded}
        style={{ width: "100%", borderRadius: "8px" }}
      />
      <div style={{ marginTop: "8px" }}>
        Видео {currentIndex + 1} из {playlist.length}
      </div>
    </div>
  );
};
